var render = function render(){var _vm=this,_c=_vm._self._c;return _c('shared-breadcrumb',{attrs:{"parent":'man-insights',"parent-text":_vm.$t('insights')}})
}
var staticRenderFns = []

export { render, staticRenderFns }